import { isTauriMode, isWebMode } from "../environmentDetector";

export const HIDE_TOP_BAR_KEY = "pos_hideTopBar";
export const HIDE_TASKBAR_KEY = "pos_hideTaskbar";
export const WINDOW_CHROME_EVENT = "pos-window-chrome";

const readFlag = (key) => {
  try {
    return localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
};

const writeFlag = (key, on) => {
  try {
    localStorage.setItem(key, on ? "true" : "false");
  } catch {
    // This workstation cannot store the choice.
  }
  window.dispatchEvent(new Event(WINDOW_CHROME_EVENT));
};

export const readHideTopBar = () => readFlag(HIDE_TOP_BAR_KEY);
export const readHideTaskbar = () => readFlag(HIDE_TASKBAR_KEY);
export const writeHideTopBar = (on) => writeFlag(HIDE_TOP_BAR_KEY, on);
export const writeHideTaskbar = (on) => writeFlag(HIDE_TASKBAR_KEY, on);

export const titleBarHidden = (posFullscreen) => isWebMode() || Boolean(posFullscreen) || readHideTopBar();

export const applyTitleBarVar = (posFullscreen) => {
  const height = titleBarHidden(posFullscreen) ? "0px" : "32px";
  document.documentElement.style.setProperty("--app-title-bar", height);
};

let queue = Promise.resolve();
let covering = false;

async function syncOs(cover) {
  const { getCurrentWindow } = await import("@tauri-apps/api/window");
  const win = getCurrentWindow();
  if (cover) {
    if (await win.isMaximized()) {
      await win.unmaximize();
    }
    if (!(await win.isFullscreen())) {
      await win.setFullscreen(true);
    }
    covering = true;
    return;
  }
  if (!covering && !(await win.isFullscreen())) return;
  if (await win.isFullscreen()) {
    await win.setFullscreen(false);
  }
  await win.setAlwaysOnTop(false);
  if (await win.isMaximized()) {
    await win.unmaximize();
  }
  await win.setResizable(false);
  covering = false;
  const { invoke } = await import("@tauri-apps/api/core");
  await invoke("fit_restored_window_command");
}

export function applyOsChrome(posFullscreen) {
  applyTitleBarVar(posFullscreen);
  if (!isTauriMode()) return;
  const cover = Boolean(posFullscreen) || readHideTaskbar();
  queue = queue.then(() => syncOs(cover)).catch((error) => {
    console.warn("[windowChrome] Could not apply the window:", error);
  });
}
